export default __webpack_public_path__ + "static/media/led_pim_skywalk.93e1540d.png";